// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ConfirmEmailPage from './pages/ConfirmEmailPage';
import ConfirmParticipationPage from './pages/ConfirmParticipationPage';
import AcceptInvitationPage from './pages/AcceptInvitationPage';

import OrganizationPage from './pages/OrganizationPage';
import OrganizationUsersPage from './pages/OrganizationUsersPage';
import EventPage from './pages/EventPage';

import SongListPage from './pages/SongListPage';

import SongDetailPage from './pages/SongDetailPage';
import ProfilePage from './pages/ProfilePage';
import EventListPage from './pages/EventListPage';
import EventRolesPage from './pages/EventRolesPage';
import CreateOrganizationPage from './pages/CreateOrganizationPage'; // Импортируем страницу создания организации

import AdminDashboard from './pages/AdminDashboard'; // Import AdminDashboard
import AdminOrganizations from './pages/AdminOrganizations';
import AdminUsers from './pages/AdminUsers';
import AdminOrganizationDetails from './pages/AdminOrganizationDetails';
import PublicLibrariesPage from './pages/PublicLibrariesPage';
import PublicLibrarySongsPage from './pages/PublicLibrarySongsPage';
import PrivacyPage from './pages/PrivacyPage';

import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/confirm-email/:token" element={<ConfirmEmailPage />} />
          <Route path="/confirm-participation/:token" element={<ConfirmParticipationPage />} />
          <Route path="/invitations/accept/:token" element={<AcceptInvitationPage />} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/events" element={<ProtectedRoute resource="event" action="read"><EventListPage /></ProtectedRoute>} />
          <Route path="/event-roles" element={<ProtectedRoute resource="eventRole" action="read"><EventRolesPage /></ProtectedRoute>} />
          <Route path="/organization/create" element={<ProtectedRoute><CreateOrganizationPage /></ProtectedRoute>} />
          <Route path="/organization/:orgId" element={<ProtectedRoute resource="organization" action="read"><OrganizationPage /></ProtectedRoute>} />
          <Route path="/organization/:orgId/users" element={<ProtectedRoute resource="userManagement" action="read"><OrganizationUsersPage /></ProtectedRoute>} />
          
          <Route path="/events/:eventId" element={<ProtectedRoute resource="event" action="read"><EventPage /></ProtectedRoute>} />
          <Route path="/songs" element={<ProtectedRoute resource="song" action="read"><SongListPage /></ProtectedRoute>} />
          <Route path="/public-libraries" element={<ProtectedRoute><PublicLibrariesPage /></ProtectedRoute>} />
          <Route path="/public-libraries/:orgId" element={<ProtectedRoute><PublicLibrarySongsPage /></ProtectedRoute>} />
          
          <Route path="/songs/:songId" element={<ProtectedRoute resource="song" action="read"><SongDetailPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute isSuperuserRoute={true}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/organizations" element={<ProtectedRoute isSuperuserRoute={true}><AdminOrganizations /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute isSuperuserRoute={true}><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/organizations/:orgId" element={<ProtectedRoute isSuperuserRoute={true}><AdminOrganizationDetails /></ProtectedRoute>} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;